import { addLabelArray } from "helpers/addLabelArray"
import { taxiTypes } from "./taxiTypes"
import { extractIDs } from "helpers/extractIDs"
import { validateObject } from "helpers/validateObject"

const {
  GET_TAXIS,

  SELECT_TAXI_COMPANY,
  SELECT_TAXI_STATIONS,

  SET_CUSTOMERS_OPT,
  SET_CUSTOMER_OPT,
  SET_CUSTOMER_STATIONS_OPT_SELECTED,
  SET_CUSTOMER_UNITS_OPT_SELECTED,

  TAXI_REGISTER_NEW,
  SET_TAXI_CUSTOMER_INFO,
  TAXI_EDIT,
  UPDATE_STATIONS_UNITS_TAXI,

  SET_CONFIG_PAGE_TAXIS,
  SET_CONFIG_PAGE_TAXIS_COUNT,
  SET_CONFIG_SORTED_TAXIS,
  SET_CONFIG_FILTERED_TAXIS,
  TAXI_RESTORE_MODAL
} = taxiTypes

const initialState = {
  taxis: [],
  taxiSelected: {},
  companySelected: {},
  stations: [],
  stationsSelected: [],
  taxisFiltered: [],
  customersOpt: [],
  customerOpt: {},
  customerStationsOpt: [],
  customerStationsOptSelected: [],
  customerUnitsOpt: [],
  customerUnitsOptSelected: [],

  config: {
    pageSize: 10,
    page: 0,
    sorted: [],
    filtered: [],
  },
}

export const taxisReducer = (state = initialState, { type, payload }) => {
  switch (type) {

    case GET_TAXIS:
      const nPayload = payload.map(taxi => {
        return {
          ...taxi,
          labelTag:  taxi.nfcTag  ? `${taxi.nfcTag.uuidTag} - ${ taxi.nfcTag.brand }` : 'Sin etiqueta'
        }
      })
      // debugger
      return {
        ...state,
        taxis: nPayload
      }
    case SELECT_TAXI_COMPANY:
      return {
        ...state,
        companySelected: payload,
        stations: payload?.stations ? payload?.stations : [],
        stationsSelected: []
      }

    case SELECT_TAXI_STATIONS:
      // const ids = extractIDs(payload)
      // const newTaxis = [...taxis]
      // let taxisFiltered = []
      // newTaxis.map(taxi => {
      //   taxi.stations.map(station => ids.includes(station.id_station) ? [{...taxi}, ...taxisFiltered] : station)
      //   return taxi
      // })
      // debugger
      return {
        ...state,
        stationsSelected: payload
      }


    case SET_CUSTOMERS_OPT:
      return {
        ...state,
        customersOpt: payload
      }

    case SET_CUSTOMER_OPT:
      return {
        ...state,
        customerOpt: payload.customer,
        customerStationsOpt: payload.stations,
        customerStationsOptSelected: payload.stations,
        customerUnitsOpt: payload.units,
        customerUnitsOptSelected: payload.units
      }

    case SET_CUSTOMER_STATIONS_OPT_SELECTED:
      return {
        ...state,
        customerStationsOptSelected: payload.stations,
        customerUnitsOpt: payload.units,
        customerUnitsOptSelected: payload.units
      }

    case SET_CUSTOMER_UNITS_OPT_SELECTED:
      return {
        ...state,
        customerUnitsOptSelected: payload
      }

    case TAXI_REGISTER_NEW:
      const nTaxi = {
        ...payload,
        labelTag:  payload.nfcTag  ? `${payload.nfcTag.uuidTag} - ${ payload.nfcTag.brand }` : 'Sin etiqueta'
      }
      return {
        ...state,
        taxis: [{...nTaxi}, ...state.taxis]
      }

    case SET_TAXI_CUSTOMER_INFO:
      return {
        ...state,
        customerOpt: payload.customer,
        customerStationsOptSelected: payload.stations,
        customerUnitsOptSelected: payload.units,
        taxiSelected: payload.taxi
      }


    case TAXI_EDIT:
      const nStateTaxis = [...state.taxis];
      const idx = nStateTaxis.findIndex(tx => tx.id === payload.id);
      if (idx === -1) {
        return state
      } else {
        nStateTaxis[idx] = {
          ...payload,
          labelTag:  payload.nfcTag  ? `${payload.nfcTag.uuidTag} - ${ payload.nfcTag.brand }` : 'Sin etiqueta'
        }

        return {
          ...state,
          taxis: nStateTaxis
        }
      }



      case UPDATE_STATIONS_UNITS_TAXI:
        return {
          ...state,
          customerStationsOpt: payload.stations,
          customerUnitsOpt: payload.units,
          customerStationsOpt: payload.available
        }


    case SET_CONFIG_PAGE_TAXIS:
      return { ...state, config: { ...state.config, page: payload } };
    case SET_CONFIG_PAGE_TAXIS_COUNT:
      return { ...state, config: { ...state.config, pageSize: payload, page: 0 } };
    case SET_CONFIG_FILTERED_TAXIS:
      return {
        ...state,
        config: {
          ...state.config,
          filtered: payload,
          page: 0,
        },
      };
    case SET_CONFIG_SORTED_TAXIS:
      return {
        ...state,
        config: {
          ...state.config,
          sorted: payload,
          page: 0,
        },
      };

    case TAXI_RESTORE_MODAL:
      return {
        ...state,
        customersOpt: [],
        customerOpt: {},
        customerStationsOpt: [],
        customerStationsOptSelected: [],
        customerUnitsOpt: [],
        customerUnitsOptSelected: [],
      }

      case SET_CONFIG_PAGE_TAXIS:
        return { ...state, config: { ...state.config, page: payload } };
    case SET_CONFIG_PAGE_TAXIS_COUNT:
        return { ...state, config: { ...state.config, pageSize: payload, page: 0 } };
    case SET_CONFIG_FILTERED_TAXIS:
        return {
            ...state,
            config: {
                ...state.config,
                filtered: payload,
                page: 0,
            },
        };
    case SET_CONFIG_SORTED_TAXIS:
        return {
            ...state,
            config: {
                ...state.config,
                sorted: payload,
                page: 0,
            },
        };
    default:
      return state
  }
}